import { aptEnsureLoaded } from "../../apt-ensure-loaded"
import { analysisStore } from "./analysis-store"

export const analysisLoader = async ({ params }) => {
  await aptEnsureLoaded(params)

  analysisStore.getState().reset()

  await Promise.all([
    analysisStore.getState().apiGetDongs(),
    analysisStore.getState().apiGetLeakUnits(),
    analysisStore.getState().apiGetLeakDongMap()
  ])

  return null
}
